module.exports = __webpack_public_path__ + "static/img/pay_wxpay_info.91acf6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/basic/pay_wxpay_info.png
// module id = AgM3
// module chunks = 0